
import { isEmpty } from 'lodash';

export default {
  name: 'AStepper',
  props: {
    data: {
      type: Array,
      required: true,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 0,
    },
    iconBeforeActive: {
      type: Object,
      default: () => ({
        name: '',
        class: '',
        type: '',
      }),
    },
    iconActive: {
      type: Object,
      // eslint-disable-next-line sonarjs/no-identical-functions
      default: () => ({
        name: '',
        class: '',
        type: '',
      }),
    },
    iconAfterActive: {
      type: Object,
      // eslint-disable-next-line sonarjs/no-identical-functions
      default: () => ({
        name: '',
        class: '',
        type: '',
      }),
    },
    iconInactive: {
      type: Object,
      // eslint-disable-next-line sonarjs/no-identical-functions
      default: () => ({
        name: '',
        class: '',
        type: '',
      }),
    },
  },
  computed: {
    isThemeDefault() {
      return this.$session.get('brand') === '';
    },
    isThemeAudi() {
      return this.$session.get('brand') === 'audi';
    },
    isThemeSeat() {
      return this.$session.get('brand') === 'seat';
    },
    isThemeVolkswagen() {
      return this.$session.get('brand') === 'volkswagen';
    },
  },
  methods: {
    isEmpty,
    selectIconName(step, index) {
      let icon = '';

      if (step - 1 > index) {
        icon = this.iconBeforeActive.name;
      }

      if (step - 1 === index) {
        icon = this.iconActive.name;
      }

      if (step === index) {
        icon = this.iconAfterActive.name;
      }

      if (step < index) {
        icon = this.iconInactive.name;
      }

      return icon;
    },
    selectIconClass(step, index) {
      let icon = '';

      if (step - 1 > index) {
        icon = this.iconBeforeActive.class;
      }

      if (step - 1 === index) {
        icon = this.iconActive.class;
      }

      if (step === index) {
        icon = this.iconAfterActive.class;
      }

      if (step < index) {
        icon = this.iconInactive.class;
      }

      return `${icon} `;
    },
    selectIconType(step, index) {
      let icon = '';

      if (step - 1 > index) {
        icon = this.iconBeforeActive.type;
      }

      if (step - 1 === index) {
        icon = this.iconActive.type;
      }

      if (step === index) {
        icon = this.iconAfterActive.type;
      }

      if (step < index) {
        icon = this.iconInactive.type;
      }

      return icon;
    },
  },
};
